




























import { Component, Vue } from "vue-property-decorator";
import QRCode from "qrcodejs2";
import VueClipboard from "vue-clipboard2"; // 复制粘贴插件
Vue.use(VueClipboard);
@Component({
  components: { QRCode },
})
export default class Home extends Vue {
  public modal = false;
  public content = "";
  public android = "";
  public ios = "";
  public confirmFn: any = null;
  public qrcodeBox: any = null;
  public urls = "";

  // 显示
  public show() {
    this.urls = window.location.href;
    this.modal = true;
    (document as any).getElementById("qrcode").innerHTML = "";
    this.qrcode();
    return new Promise((resolve) => {
      this.confirmFn = () => {
        resolve(1);
      };
    });
  }
  public stopModal() {
    setTimeout(() => {
      if (this.modal === false) {
        this.modal = true;
      }
    });
  }
  //  生成二维码
  public qrcode() {
    const that = this;
    this.qrcodeBox = new QRCode("qrcode", {
      width: 180,
      height: 180, // 高度
      text: "http://land.996box.com/mobilepage/index.html", // 二维码内容
      // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      // background: '#f0f',   // 背景色
      // foreground: '#ff0'    // 前景色
    });
  }
}
